<template>
    <div :class="classes">
        <svg fill="#currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" :class="iconClasses || 'w-5 h-5'">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path
                    d="M1,16V8A1,1,0,0,1,3,8v8a1,1,0,0,1-2,0Zm7,4V4A1,1,0,0,0,6,4V20a1,1,0,0,0,2,0Zm5,2V2a1,1,0,0,0-2,0V22a1,1,0,0,0,2,0Zm5-2V4a1,1,0,0,0-2,0V20a1,1,0,0,0,2,0ZM22,7a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V8A1,1,0,0,0,22,7Z">
                </path>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    name: "AudioIcon",
    props: {
        fill: {
            type: String,
            default: "currentColor",
        },
        classes: {
            type: String,
            default: "",
        },
        iconClasses: {
            type: String,
            default: "",
        },
    },
}

</script>